module.exports = __webpack_public_path__ + "img/tune-your-text.3dc5e4af.png";